import { IVec3 } from '@stair-craft/common/util';

export function buildFlightSawtoothNegZ(
    stepCount: number,
    treadDepth: number,
    x: number,
    startZ: number,
    entryY: number,
    exitY: number,
    riserHeight: number
): IVec3[] {
    const points: IVec3[] = [{ x, y: entryY, z: startZ }];
    for (let j: number = 0; j < stepCount; j++) {
        const zFront: number = startZ - j * treadDepth;
        const zBack: number = startZ - (j + 1) * treadDepth;
        const stepY: number = entryY + (j + 1) * riserHeight;
        points.push({ x, y: stepY, z: zFront });
        points.push({ x, y: stepY, z: zBack });
    }
    points.push({ x, y: exitY, z: startZ - stepCount * treadDepth });
    return points;
}
